import React, { useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import navigation from "@src/navigation";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router";
import { TTLIcon, FBIcon, YoutubeIcon, TiktokIcon } from "@src/assets/svg";
import Switch from "@components/Switch";
import { SearchIcon } from "@Modules/Partner/assets/svg";
import { getShareInfoSelector } from "@store/common/selectors";
import { useMediaQuery } from "react-responsive";

const Drawer = ({ visible, setVisible }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isIpadPro = useMediaQuery({ minWidth: 992, maxWidth: 1199 });
  const history = useHistory();

  const formData = useSelector((state) => getShareInfoSelector(state));
  const refDrawer = useRef();
  const { url } = useRouteMatch();

  // below is the same as componentDidMount and componentDidUnmount
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (refDrawer.current && !refDrawer.current.contains(event.target)) {
      setVisible(false);
    }
  };

  const _handleSearch = () => {};

  const push = (to) => {
    history.push(to);
    setVisible(false);
  };

  return (
    <div className="sidebar-modal drawer-header">
      <div
        className="modal left fade show"
        style={{
          display: "block",
          paddingRight: "16px",
        }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content" ref={refDrawer}>
            <div className="modal-body">
              <div className="sidebar-modal-widget list-menu">
                {navigation && navigation.length
                  ? navigation.map((item) => (
                      <ul
                        className={`parent ${item.to === url ? "active" : ""}`}
                        key={item.id}
                      >
                        <li>
                          {!item.submenu.length ? (
                            <a
                              onClick={() => push(item.to)}
                              className="title-menu"
                            >
                              {item.titleI18n ? t(item.titleI18n) : item.title}
                            </a>
                          ) : (
                            <>
                              <input type="checkbox" id={item.id} />
                              <label htmlFor={item.id} className="title-menu">
                                {item.titleI18n
                                  ? t(item.titleI18n)
                                  : item.title}
                              </label>

                              <ul className="child">
                                {item.submenu.map((sub, index) => (
                                  <li key={sub.id || `sub-${index}`}>
                                    <a onClick={() => push(sub.to)}>
                                      {sub.titleI18n
                                        ? t(sub.titleI18n)
                                        : sub.title}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}
                        </li>
                      </ul>
                    ))
                  : null}
              </div>
            </div>

            {!isIpadPro && (
              <div className="modal-footer">
                <div className="btn-footer">
                  <a
                  href="https://www.5phutthuocbai.com/buycourse"
                      target="_blank"
                      className="btn-top btn-top-primary">
                    {t("MENU:buyCourse")}
                  </a>

                  <Link to="/download" className="btn-top btn-top-primary nptb">
                    <img
                      src={
                        require("@src/assets/images/nav-bottom/5ptb.png")
                          .default
                      }
                      alt="5-minutes"
                    />
                    &nbsp;
                    {t("MENU:5minutes")}
                  </Link>
                </div>

                <div className="search-footer">
                  <div className="search-footer__social">
                    <ul className="list-btn-social">
                      <li className="social-list">
                        <a
                          onClick={() =>
                            window.open(formData.link_TTL, "_blank").focus()
                          }
                          className="social-btn ttl"
                        >
                          <TTLIcon />
                        </a>
                        <a
                          onClick={() =>
                            window
                              .open(formData.link_Facebook, "_blank")
                              .focus()
                          }
                          className="social-btn fb"
                        >
                          <FBIcon />
                        </a>
                        <a
                          onClick={() =>
                            window.open(formData.link_Youtube, "_blank").focus()
                          }
                          className="social-btn ytb"
                        >
                          <YoutubeIcon />
                        </a>
                        <a
                          onClick={() =>
                            window.open(formData.link_Tictok, "_blank").focus()
                          }
                          className="social-btn tiktok"
                        >
                          <TiktokIcon />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            <div className="star2__drawer tablet">
              <img
                src={require("@src/assets/images/star-2.png").default}
                alt="star"
              />
            </div>
            <div className="star3__drawer tablet">
              <img
                src={require("@src/assets/images/star-3.png").default}
                alt="star"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Drawer;
